import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLazyQuery } from 'react-apollo'

import { useRestaurant } from '../../RestaurantProvider/RestaurantProvider'

import { MENU_ITEM_DETAILS } from '../../../apollo/menu/menuitem.graphql'
import { useAddItemToCart } from '../../CartMutation/CartMutation'

import { UpdateItemFormModal } from '../UpdateItemFormModal/UpdateItemFormModal'

import { useFulfillment } from '../../FulfillmentProvider/FulfillmentProvider'
import { useNestedModifiers } from '../use-nested-modifiers'
import { useOutpostRestaurant } from '../../OutpostProvider/OutpostProvider'

export const AddItem = ({
  itemGuid,
  itemGroupGuid,
  onClose
}) => {
  const { shortUrl } = useRestaurant()
  const { fulfillmentTime, loading } = useFulfillment()
  const { outpostDeliveryDateTime } = useOutpostRestaurant()
  const dateTime = outpostDeliveryDateTime || fulfillmentTime || undefined
  const { nestingLevel } = useNestedModifiers()

  const [getMenuItemDetails, itemDetailsQuery] = useLazyQuery(MENU_ITEM_DETAILS, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
    variables: {
      input: { shortUrl, itemGuid, itemGroupGuid, dateTime },
      nestingLevel
    }
  })

  const [addItemToCart, { error }] = useAddItemToCart({ onCompleted: onClose })

  useEffect(() => {
    if (!loading) getMenuItemDetails()
  }, [getMenuItemDetails, loading])

  const getItemDetails = (data = {}) => {
    const { menuItemDetails } = data
    if (!menuItemDetails) return null

    return {
      ...menuItemDetails,
      usesFractionalQuantity: !!(menuItemDetails.unitOfMeasure && menuItemDetails.unitOfMeasure !== 'NONE'),
      unitOfMeasure: menuItemDetails.unitOfMeasure || '',
      fractionalQuantity: {}
    }
  }

  const getBasePrice = (data = {}) => (data.menuItemDetails && data.menuItemDetails.price) || 0

  return (
    <UpdateItemFormModal
      updateCart={addItemToCart}
      error={error}
      itemDetailsQuery={itemDetailsQuery}
      getItemDetails={getItemDetails}
      getBasePrice={getBasePrice}
      onClose={onClose}
      itemGuid={itemGuid}
      itemGroupGuid={itemGroupGuid}
    />
  )
}

AddItem.propTypes = {
  itemGuid: PropTypes.string.isRequired,
  itemGroupGuid: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
}
